import { Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { AwdurdodiService } from "src/app/craidd/gwasanaethau/awdurdodi/awdurdodi.service";
import { HawlModiwlService } from "src/app/craidd/gwasanaethau/awdurdodi/hawl-modiwl.service";
import { IaithRouterService } from "src/app/craidd/gwasanaethau/iaith/iaith-router.service";
import { Rol } from "src/app/craidd/modelau/defnyddiwr/rol";
import { Modiwl } from "src/app/craidd/modelau/system/modiwl";
import { IEitemSidenav } from "src/app/craidd/modelau/ui/eitem-sidenav";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { MatNavList, MatListItem } from "@angular/material/list";
import { BwletinNewyddComponent } from "../bwletin-newydd/bwletin-newydd.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-sidebar-dewislen",
  templateUrl: "./sidebar-dewislen.component.html",
  styleUrl: "./sidebar-dewislen.component.scss",
  imports: [FaIconComponent, MatNavList, MatListItem, RouterLink, BwletinNewyddComponent, TranslatePipe],
})
export class SidebarDewislenComponent implements OnInit {
  routeWediDdewis: string | null = null;

  eitemauDewislen: IEitemSidenav[] = [
    {
      teitl: "ui.cartref",
      eicon: "home",
      route: "/cartref",
      mynediad: Rol.Defnyddiwr,
      hawl: Modiwl.Cartref,
      plant: [
        {
          teitl: "ui.dangosfwrdd",
          eicon: "list",
          route: "/cartref",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.bwletin",
          eicon: "file-alt",
          route: "/bwletin",
          mynediad: Rol.Mecanig,
          hawl: Modiwl.Cerbyd,
        },
      ],
    },
    {
      teitl: "ui.cerbydau",
      eicon: "car",
      route: "/cerbyd",
      mynediad: Rol.Defnyddiwr,
      hawl: Modiwl.Cerbyd,
      plant: [
        {
          teitl: "ui.dangosfwrdd",
          eicon: "list",
          route: "/cerbyd",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.tanwydd",
          eicon: "gas-pump",
          route: "/cerbyd/tanwydd",
          mynediad: Rol.Gweinyddwr,
        },
        {
          teitl: "ui.damweiniau",
          eicon: "car-crash",
          route: "/damwain",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.hurio",
          eicon: "taxi",
          route: "/archeb/hurio",
          mynediad: Rol.Defnyddiwr,
        },
      ],
    },
    {
      teitl: "ui.gwaith",
      eicon: "wrench",
      route: "/gwaith",
      mynediad: Rol.Defnyddiwr,
      hawl: Modiwl.Gwaith,
      plant: [
        {
          teitl: "ui.dangosfwrdd",
          eicon: "list",
          route: "/gwaith",
          mynediad: Rol.Mecanig,
        },
        {
          teitl: "ui.calendr",
          eicon: "calendar-alt",
          route: "/amserlennu",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.ffurflenniarchwiliodiogelwch",
          eicon: "tasks",
          route: "/diogelwch",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.ffurflennigwiriodyddiol",
          eicon: "user-check",
          route: "/gwirio",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.diffygion",
          eicon: "exclamation-triangle",
          route: "/gwirio/diffyg",
          mynediad: Rol.Mecanig,
        },
        {
          teitl: "ui.gwyliau",
          eicon: "calendar-alt",
          route: "/gwaith/gwyliau",
          mynediad: Rol.Gweinyddwr,
        },
      ],
    },
    {
      teitl: "ui.dyroddiad",
      eicon: "clipboard-list",
      route: "/",
      mynediad: Rol.Defnyddiwr,
      hawl: Modiwl.DogfenDyroddiad,
      plant: [
        {
          teitl: "ui.dangosfwrdd",
          eicon: "list",
          route: "/dyroddiad",
          mynediad: Rol.Defnyddiwr,
        },
      ],
    },
    // Archebion
    {
      teitl: "ui.archebion",
      eicon: "shopping-cart",
      mynediad: Rol.Mecanig,
      hawl: Modiwl.Gwaith,
      plant: [
        {
          teitl: "ui.stoc",
          eicon: "shopping-cart",
          route: "/archeb",
          mynediad: Rol.Mecanig,
        },
        {
          teitl: "ui.cerbydau",
          eicon: "car",
          route: "/archeb/cerbyd",
          mynediad: Rol.Gweinyddwr,
        },
        {
          teitl: "ui.arall",
          eicon: "shopping-basket",
          route: "/archeb/arall",
          mynediad: Rol.Gweinyddwr,
        },
        {
          teitl: "ui.cyflenwyr",
          eicon: "truck-loading",
          route: "/cyflenwr",
          mynediad: Rol.Mecanig,
        },
      ],
    },
    // Stoc gwaith
    {
      teitl: "ui.stoc",
      eicon: "boxes",
      mynediad: Rol.Mecanig,
      hawl: Modiwl.Gwaith,
      plant: [
        {
          teitl: "ui.dangosfwrdd",
          eicon: "list",
          route: "/stoc",
          mynediad: Rol.Mecanig,
        },
        {
          teitl: "ui.storfa",
          eicon: "warehouse",
          route: "/storfa",
          mynediad: Rol.Mecanig,
        },
      ],
    },
    // Stoc modiwl Dogfen Dyroddiad
    {
      teitl: "ui.stoc",
      eicon: "boxes",
      mynediad: Rol.Defnyddiwr,
      hawl: Modiwl.DogfenDyroddiad,
      plant: [
        {
          teitl: "ui.archebion",
          eicon: "shopping-cart",
          route: "/archeb",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.stoc",
          eicon: "boxes",
          route: "/stoc",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.storfa",
          eicon: "warehouse",
          route: "/storfa",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.cyflenwr",
          eicon: "truck-loading",
          route: "/cyflenwr",
          mynediad: Rol.Defnyddiwr,
        },
      ],
    },
    // Gyrrwr
    {
      teitl: "ui.gyrwyr",
      eicon: "users",
      mynediad: Rol.UwchWeinyddwr,
      hawl: Modiwl.Gyrrwr,
      plant: [
        {
          teitl: "ui.dangosfwrdd",
          eicon: "list",
          route: "/gyrrwr",
          mynediad: Rol.UwchWeinyddwr,
        },
        {
          teitl: "ui.trwyddedau",
          eicon: "id-card",
          route: "/gyrrwr/trwydded",
          mynediad: Rol.UwchWeinyddwr,
        },
      ],
    },
    // Data
    {
      teitl: "ui.data",
      eicon: "floppy-disk",
      mynediad: Rol.Defnyddiwr,
      plant: [
        {
          teitl: "ui.adroddiadau",
          eicon: "file-alt",
          route: "/adroddiad",
          mynediad: Rol.Defnyddiwr,
        },
        {
          teitl: "ui.uwchlwytho",
          eicon: "upload",
          route: "/uwchlwytho",
          mynediad: Rol.Gweinyddwr,
          hawl: Modiwl.Data,
        },
      ],
    },
    // Gwaith
    {
      teitl: "ui.gweinyddol",
      eicon: "cog",
      mynediad: Rol.Gweinyddwr,
      hawl: Modiwl.Gwaith,
      plant: [
        {
          teitl: "ui.defnyddwyr",
          eicon: "users",
          route: "/defnyddiwr",
          mynediad: Rol.UwchWeinyddwr,
        },
        {
          teitl: "ui.gwaithgweinyddu",
          eicon: "wrench",
          route: "/gwaith/gweinyddu",
          mynediad: Rol.UwchWeinyddwr,
          hawl: Modiwl.Gwaith,
        },
        {
          teitl: "ui.patrymaugwasanaeth.teitl",
          eicon: "calendar-alt",
          route: "/amserlennu/paramedr",
          mynediad: Rol.Gweinyddwr,
        },
        {
          teitl: "ui.amserlennugweithdai",
          eicon: "warehouse",
          route: "/amserlennu/gweithdy",
          mynediad: Rol.Gweinyddwr,
        },
        {
          teitl: "ui.iaith",
          eicon: "language",
          route: "/iaith",
          mynediad: Rol.UwchWeinyddwr,
        },
        {
          teitl: "ui.opsiynau",
          eicon: "filter",
          route: "/opsiwn",
          mynediad: Rol.Gweinyddwr,
        },
      ],
    },
    // Dyroddiad dogfen
    {
      teitl: "ui.gweinyddol",
      eicon: "cog",
      mynediad: Rol.UwchWeinyddwr,
      hawl: Modiwl.DogfenDyroddiad,
      plant: [
        {
          teitl: "ui.defnyddwyr",
          eicon: "users",
          route: "/defnyddiwr",
          mynediad: Rol.UwchWeinyddwr,
        },
        {
          teitl: "ui.iaith",
          eicon: "language",
          route: "/iaith",
          mynediad: Rol.UwchWeinyddwr,
        },
        {
          teitl: "ui.opsiynau",
          eicon: "filter",
          route: "/opsiwn",
          mynediad: Rol.UwchWeinyddwr,
        },
      ],
    },
  ];

  constructor(
    private awdurdodiService: AwdurdodiService,
    private hawlModiwlService: HawlModiwlService,
    private router: Router,
    public iaithRouterService: IaithRouterService,
  ) {}

  ngOnInit(): void {}

  ynActive(route: string): boolean {
    let currentPath = this.router.url.substring(3);

    if (route === this.routeWediDdewis || route === currentPath) {
      return true;
    }

    return false;
  }

  ynCaelMynediad(rol: Rol): boolean {
    return this.awdurdodiService.gwirioRol(rol);
  }

  ynCaelHawl(modiwl: Modiwl): boolean {
    if (!modiwl) {
      return true;
    }

    return this.hawlModiwlService.gwirioHawl(modiwl);
  }

  expandedClass(): string {
    return "collapsed";
  }
}
